/* eslint-disable no-unused-expressions */
// "use strict";

// Chat And Feed Related Firebase Functions
// note that this file is compiled from typescript chatstratts.ts
// use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatServiceInitialStrategy = void 0;
var app_1 = require("firebase/app");
var uuid_1 = require("uuid");
var firestore_1 = require("firebase/firestore");
var auth_1 = require("firebase/auth");
var ChatServiceInitialStrategy = /** @class */ (function () {
    function ChatServiceInitialStrategy(userObject, firebaseConfig, tokenstring, communityId, communityRole) {
        if (communityId === void 0) { communityId = ""; }
        if (communityRole === void 0) { communityRole = ""; }
        this.userId = "unknownUser";
        // private messageChannelList : string[];
        // private messageChannelCallbackMap : Map<string, (data:any)=>{}>;
        this.namedQueriesMap = new Map();
        // These Variables are constantly updated by websocket Connection
        this.wsAllConversationDocs = [];
        //A list of all callback functions that are actively subscribed to firebase websocker
        this.unSubscribeArrayList = new Array;
        //   this.name = "hello";
        // console.log("THE FIREBASE CONFIG FILE : ", firebaseConfig);
        // this.app = initializeApp(firebaseConfig,"trybz-staging");
        this.app = (0, app_1.initializeApp)(firebaseConfig, firebaseConfig.databaseId);
        this.userObject = userObject, this.userId = userObject["userId"];
        if (firebaseConfig.databaseId) {
            this.auth = (0, auth_1.getAuth)(this.app);
        }
        if (firebaseConfig.databaseId && this.auth) {
            (0, auth_1.signInWithCustomToken)(this.auth, tokenstring).then(function (res) {
                // console.log("TOken SignIn res : ", res);
            });
            // console.log("TOKEN SIGN IN")
        }
        if (firebaseConfig.databaseId) {
            this.db = (0, firestore_1.getFirestore)(this.app, firebaseConfig.databaseId);
        }
        else {
            this.db = (0, firestore_1.getFirestore)(this.app);
        }
        // this.initWebSocketRequests()
        this.communityId = communityId;
        this.communityRole = communityRole;
        //Or use the userId to get the user object.
        // this.userObject = userObject;
        // this.initWebSocketRequests()
    }
    ChatServiceInitialStrategy.prototype.initWebSocketRequests = function () {
        var _this = this;
        // Helps keep latest version of conversation collection
        var callbackUnsub = this.subscribeToConversationEventHandler(function (data) {
            _this.wsAllConversationDocs = data.map(function (val) { return Object.fromEntries(__spreadArray(__spreadArray([], Object.entries(val), true), [["id", val.id]], false)); });
        }, function (error) {
            console.log("Error With firestore Stream : ", error);
        });
        this.unSubscribeArrayList.push(callbackUnsub);
    };
    ChatServiceInitialStrategy.prototype.QuerygetConversationRecipient = function (userId) {
        var colc = (0, firestore_1.collection)(this.db, "Conversations/".concat(userId, "/Recipients/"));
        var q = (0, firestore_1.query)(colc);
        return q;
    };
    ChatServiceInitialStrategy.prototype.QuerygetConversationGroup = function (userId) {
        var colc = (0, firestore_1.collection)(this.db, "Conversations/".concat(userId, "/Groups/"));
        var q = (0, firestore_1.query)(colc);
        return q;
    };
    ChatServiceInitialStrategy.prototype.QuerygetRoleSpecificGroupMessages = function (communityId) {
        var colc = (0, firestore_1.collectionGroup)(this.db, "Groups");
        var q = (0, firestore_1.query)(colc, (0, firestore_1.where)("communityId", "==", communityId));
        return q;
    };
    ChatServiceInitialStrategy.prototype.QuerygetMessagesById = function (msgId) {
        return (0, firestore_1.query)((0, firestore_1.collection)(this.db, "/Chats/".concat(msgId, "/Messages")));
    };
    ChatServiceInitialStrategy.prototype.QuerygetMessagesByIdAndTime = function (msgId, timeVal) {
        return (0, firestore_1.query)((0, firestore_1.collection)(this.db, "/Chats/".concat(msgId, "/Messages")), (0, firestore_1.where)("timeSent", ">=", timeVal));
    };
    ChatServiceInitialStrategy.prototype.QuerygetLatestMessage = function (msgId) {
        return (0, firestore_1.query)((0, firestore_1.collection)(this.db, "/Chats/".concat(msgId, "/Messages")), (0, firestore_1.orderBy)("timeSent", "desc"), (0, firestore_1.limit)(1));
    };
    ChatServiceInitialStrategy.prototype.QuerygetLatestNMessages = function (msgId, N) {
        return (0, firestore_1.query)((0, firestore_1.collection)(this.db, "/Chats/".concat(msgId, "/Messages")), (0, firestore_1.orderBy)("timeSent", "desc"), (0, firestore_1.limit)(N));
    };
    ChatServiceInitialStrategy.prototype.QuerygetLatestNMessagesBeforeTime = function (msgId, N, beforeTime) {
        return (0, firestore_1.query)((0, firestore_1.collection)(this.db, "/Chats/".concat(msgId, "/Messages")), (0, firestore_1.where)("timeSent", "<", beforeTime), (0, firestore_1.orderBy)("timeSent", "desc"), (0, firestore_1.limit)(N));
    };
    ChatServiceInitialStrategy.prototype.QuerygetConversationWithSpecificRecipient = function (userId, recipientId) {
        var colc = (0, firestore_1.collection)(this.db, "Conversations/".concat(userId, "/Recipients"));
        var q = (0, firestore_1.query)(colc, (0, firestore_1.where)("Document ID", "==", userId));
        return q;
    };
    ChatServiceInitialStrategy.prototype.QuerygetConversationWithWithSpecificMessageIdNUserId = function (userId, msgId, groupOrRecipient) {
        if (groupOrRecipient === void 0) { groupOrRecipient = "Recipients"; }
        // console.log("Logging TypeOf : ", typeof groupOrRecipient, groupOrRecipient)
        var colc = (0, firestore_1.collection)(this.db, "Conversations/".concat(userId, "/").concat(groupOrRecipient));
        var q = (0, firestore_1.query)(colc, (0, firestore_1.where)("messageId", "==", msgId));
        return q;
    };
    ChatServiceInitialStrategy.prototype.QuerygetAllConversationWithSpecificMessageId = function (msgId, groupOrRecipient) {
        if (groupOrRecipient === void 0) { groupOrRecipient = "Recipients"; }
        // console.log("Logging TypeOf : ", typeof groupOrRecipient, groupOrRecipient)
        var colc = (0, firestore_1.collectionGroup)(this.db, groupOrRecipient);
        var q = (0, firestore_1.query)(colc, (0, firestore_1.where)("messageId", "==", msgId));
        return q;
    };
    //Hives
    ChatServiceInitialStrategy.prototype.QuerygetAllFeedsByCommunityId = function (communityId) {
        var colc = (0, firestore_1.collectionGroup)(this.db, "Feeds");
        var q = (0, firestore_1.query)(colc, (0, firestore_1.where)("communityId", "==", communityId));
        return q;
    };
    // QuerygetFeedByFeedId( feedId: string){
    //     return query(doc(this.db,`/Feeds/${feedId}`))
    // }
    ChatServiceInitialStrategy.prototype.isGroupAdmin = function (groupsSnapShotObject) {
        var _this = this;
        var filterResult = groupsSnapShotObject.docs[0].data()["groupAdmins"]
            .filter(function (val, ind, arr) {
            return val["userId"] == _this.userId;
        });
        return filterResult.length > 0;
    };
    //TODO
    ChatServiceInitialStrategy.prototype.addParticipantToGroup = function (msgId, participantUserArr, forceAcceptance) {
        return __awaiter(this, void 0, void 0, function () {
            var returnMessage;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        returnMessage = { state: "error", message: "" };
                        return [4 /*yield*/, (0, firestore_1.runTransaction)(this.db, function (trans) { return __awaiter(_this, void 0, void 0, function () {
                                var groupsSnapSHot, groupId_1, groupTemplateData_1;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, (0, firestore_1.getDocs)(this.QuerygetAllConversationWithSpecificMessageId(msgId, "Groups"))];
                                        case 1:
                                            groupsSnapSHot = _a.sent();
                                            if (!(!this.isGroupAdmin(groupsSnapSHot) && false)) return [3 /*break*/, 2];
                                            returnMessage = Promise.reject({ "state": "Error", "message": "You dont have the right previlage" });
                                            return [3 /*break*/, 4];
                                        case 2:
                                            groupId_1 = "";
                                            groupTemplateData_1 = {};
                                            groupsSnapSHot.docs.forEach(function (groupDoc, ind, arr) { return __awaiter(_this, void 0, void 0, function () {
                                                var oldInvitees, oldParticipants, newInvitees, newParticipants;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0:
                                                            groupId_1 = groupDoc.data()["groupId"]; //Am aware this will be assigned multiple times per iteration but it will all be the same value sooo,
                                                            oldInvitees = groupDoc.data()["invites"];
                                                            oldParticipants = groupDoc.data()["recipients"];
                                                            newInvitees = __spreadArray(__spreadArray([], oldInvitees, true), (participantUserArr.map(function (val, ind, arr) { return { chatUser: val, status: forceAcceptance ? "accepted" : "pending" }; })), true);
                                                            newParticipants = __spreadArray(__spreadArray([], oldParticipants, true), participantUserArr, true);
                                                            groupTemplateData_1 = __assign(__assign({}, (groupDoc.data())), { recipients: newParticipants, invites: newInvitees });
                                                            return [4 /*yield*/, trans.update(groupDoc.ref, groupTemplateData_1)];
                                                        case 1:
                                                            _a.sent();
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); });
                                            return [4 /*yield*/, participantUserArr.forEach(function (participantUserObject, ind, arr) { return __awaiter(_this, void 0, void 0, function () {
                                                    var thenewDoc;
                                                    return __generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0:
                                                                thenewDoc = (0, firestore_1.doc)(this.db, "Conversations/".concat(participantUserObject["id"] ? participantUserObject["id"] : participantUserObject["userId"], "/Groups/").concat(groupId_1));
                                                                return [4 /*yield*/, trans.set(thenewDoc, groupTemplateData_1)];
                                                            case 1:
                                                                _a.sent();
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                }); })];
                                        case 3:
                                            _a.sent();
                                            returnMessage = Promise.resolve({ "state": "Successful", "message": "" });
                                            _a.label = 4;
                                        case 4: return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, returnMessage];
                }
            });
        });
    };
    ChatServiceInitialStrategy.prototype.removeParticipantFromGroup = function (msgId, participantId) {
        return __awaiter(this, void 0, void 0, function () {
            var groupsSnapSHot, groupId, returnMessage, filterResult, theDoc;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, firestore_1.getDocs)(this.QuerygetAllConversationWithSpecificMessageId(msgId, "Groups"))];
                    case 1:
                        groupsSnapSHot = _a.sent();
                        groupId = "";
                        returnMessage = Promise.resolve({ "state": "Error", "message": "" });
                        filterResult = groupsSnapSHot.docs[0].data()["groupAdmins"]
                            .filter(function (val, ind, arr) {
                            return val["userId"] == _this.userId;
                        });
                        if (!(filterResult.length <= 0 && false)) return [3 /*break*/, 2];
                        returnMessage = Promise.reject({ "state": "Error", "message": "You dont have the right previlage" });
                        return [3 /*break*/, 4];
                    case 2:
                        groupsSnapSHot.docs.forEach(function (groupDoc, ind, arr) { return __awaiter(_this, void 0, void 0, function () {
                            var oldInvitees, oldParticipants, newInvitees, newParticipants;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        groupId = groupDoc.data()["groupId"]; //Am aware this will be assigned multiple times per iteration but it will all be the same value sooo,
                                        oldInvitees = groupDoc.data()["invites"];
                                        oldParticipants = groupDoc.data()["recipients"];
                                        newInvitees = oldInvitees.filter(function (val, indd, arrr) {
                                            return val["chatUser"]["userId"] != participantId;
                                        });
                                        newParticipants = oldParticipants.filter(function (val, indd, arrr) {
                                            return val["userId"] != participantId;
                                        });
                                        return [4 /*yield*/, (0, firestore_1.updateDoc)(groupDoc.ref, __assign(__assign({}, (groupDoc.data())), { recipients: newParticipants, invites: newInvitees }))];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        theDoc = (0, firestore_1.doc)(this.db, "Conversations/".concat(participantId, "/Groups/").concat(groupId));
                        return [4 /*yield*/, (0, firestore_1.deleteDoc)(theDoc)];
                    case 3:
                        _a.sent();
                        returnMessage = Promise.resolve({ "state": "Successful", "message": "" });
                        _a.label = 4;
                    case 4: return [2 /*return*/, returnMessage];
                }
            });
        });
    };
    // Works
    ChatServiceInitialStrategy.prototype.getConversations = function () {
        return __awaiter(this, void 0, void 0, function () {
            var q, querySnapShot;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        q = this.QuerygetConversationRecipient(this.userId);
                        return [4 /*yield*/, (0, firestore_1.getDocs)(q)];
                    case 1:
                        querySnapShot = _a.sent();
                        querySnapShot.docs[0].data()["invites"];
                        return [2 /*return*/, querySnapShot.docs.filter(function (val, ind, arr) {
                                var arrobj = val.data()["invites"];
                                var count = arrobj.filter(function (invite, ind, arr) {
                                    return invite["chatUser"]["userId"] == _this.userId && ["accepted", "pending"].includes(invite["status"]);
                                }).length;
                                return count > 0;
                            }).map(function (val) { return Object.fromEntries(__spreadArray(__spreadArray([], Object.entries(val.data()), true), [["id", val.id]], false)); })];
                }
            });
        });
    };
    //Works So Far
    ChatServiceInitialStrategy.prototype.subscribeToConversationEventHandler = function (next, error) {
        var _this = this;
        //Hopefully a change in Conversations is triggered only when there is a new conversation
        //this.subscibeToConversationEventHandler = func
        var unsubscribecallback = (0, firestore_1.onSnapshot)(this.QuerygetConversationRecipient(this.userId), {
            next: function (data) {
                // console.log("DataDocst :", data, data.docs)
                var results = data.docs.filter(function (val, ind, arr) {
                    var arrobj = val.data()["invites"];
                    var count = arrobj.filter(function (invite, ind, arr) {
                        return invite["chatUser"]["userId"] == _this.userId && ["accepted", "pending"].includes(invite["status"]);
                    }).length;
                    return count > 0;
                }).map(function (val) { return Object.fromEntries(__spreadArray(__spreadArray([], Object.entries(val.data()), true), [["docId", val.id]], false)); });
                next(results);
            },
            error: function (error) { console.log("Error With firestore Stream : ", error); }
        });
        this.unSubscribeArrayList.push(unsubscribecallback);
        return unsubscribecallback;
    };
    ChatServiceInitialStrategy.prototype.subscribeToConversationRecipentEventHandlerWithPredicate = function (next, error, predicate) {
        var _this = this;
        //Hopefully a change in Conversations is triggered only when there is a new conversation
        //this.subscibeToConversationEventHandler = func
        var unsubscribecallback = (0, firestore_1.onSnapshot)(this.QuerygetConversationRecipient(this.userId), {
            next: function (data) {
                // console.log("DataDocst :", data, data.docs)
                var results = data.docs.filter(function (val, ind, arr) {
                    var objobj = val.data();
                    var arrobj = objobj["invites"];
                    var count = arrobj.filter(function (invite, ind, arr) {
                        return invite["chatUser"]["userId"] == _this.userId && ["accepted", "pending"].includes(invite["status"]) && predicate(objobj, ind, arr);
                    }).length;
                    return count > 0;
                }).map(function (val) { return Object.fromEntries(__spreadArray(__spreadArray([], Object.entries(val.data()), true), [["docId", val.id]], false)); });
                next(results);
            },
            error: function (error) { console.log("Error With firestore Stream with Predicate : ", error); }
        });
        this.unSubscribeArrayList.push(unsubscribecallback);
        return unsubscribecallback;
    };
    ChatServiceInitialStrategy.prototype.subscribeToConversationGroupEventHandlerWithPredicate = function (next, error, predicate) {
        var _this = this;
        //Hopefully a change in Conversations is triggered only when there is a new conversation
        //this.subscibeToConversationEventHandler = func
        var unsubscribecallback = (0, firestore_1.onSnapshot)(this.QuerygetConversationGroup(this.userId), {
            next: function (data) {
                // console.log("DataDocst :", data, data.docs)
                var results = data.docs.filter(function (val, ind, arr) {
                    var objobj = val.data();
                    var arrobj = objobj["invites"];
                    var count = arrobj.filter(function (invite, ind, arr) {
                        return invite["chatUser"]["userId"] == _this.userId && ["accepted", "pending"].includes(invite["status"]) && predicate(objobj, ind, arr);
                    }).length;
                    return count > 0;
                }).map(function (val) { return Object.fromEntries(__spreadArray(__spreadArray([], Object.entries(val.data()), true), [["docId", val.id]], false)); });
                next(results);
            },
            error: function (error) { console.log("Error With firestore group Stream with Predicate : ", error); }
        });
        this.unSubscribeArrayList.push(unsubscribecallback);
        return unsubscribecallback;
    };
    ChatServiceInitialStrategy.prototype.subscribeToCommunityRoleSpecificGroupEventHandlerWithPredicate = function (next, erroror, predicate) {
        var unsubscribecallback = (0, firestore_1.onSnapshot)(this.QuerygetRoleSpecificGroupMessages(this.communityId), {
            next: function (data) {
                // console.log("Falser RolespecificChanges" , data.docChanges());
                var results = data.docs.filter(function (val, ind, arr) {
                    var objobj = val.data();
                    return predicate(objobj, ind, arr);
                }).map(function (val) { return Object.fromEntries(__spreadArray(__spreadArray([], Object.entries(val.data()), true), [["docId", val.id]], false)); });
                next(results);
            },
            error: function (error) { erroror(error); }
        });
        this.unSubscribeArrayList.push(unsubscribecallback);
        return unsubscribecallback;
    };
    ChatServiceInitialStrategy.prototype.subscribeToFeedsByCommunityIdWithPredicate = function (next, errorHandler, predicate) {
        var unsubscribecallback = (0, firestore_1.onSnapshot)(this.QuerygetAllFeedsByCommunityId(this.communityId), function (data) {
            var results = data.docs.filter(function (val, ind, arr) {
                return predicate(val.data(), ind, arr);
            }).map(function (val) { return Object.fromEntries(__spreadArray(__spreadArray([], Object.entries(val.data()), true), [["docId", val.id]], false)); });
            next(results);
        }, function (error) {
            errorHandler(error);
        });
        return unsubscribecallback;
    };
    ChatServiceInitialStrategy.prototype.commentOnFeed = function (feedId, commentText) {
        return __awaiter(this, void 0, void 0, function () {
            var ex_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, firestore_1.runTransaction)(this.db, function (trans) { return __awaiter(_this, void 0, void 0, function () {
                                var feedDoc, originalComments, commentObject;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, trans.get((0, firestore_1.doc)(this.db, "Feeds/".concat(feedId)))];
                                        case 1:
                                            feedDoc = _a.sent();
                                            if (!feedDoc) return [3 /*break*/, 3];
                                            originalComments = feedDoc.data()["comments"];
                                            commentObject = {
                                                comment: commentText,
                                                commenter: this.userObject,
                                                createdAt: firestore_1.Timestamp.now()
                                            };
                                            return [4 /*yield*/, trans.update(feedDoc.ref, { comments: __spreadArray(__spreadArray([], originalComments, true), [commentObject], false) })];
                                        case 2: return [2 /*return*/, _a.sent()];
                                        case 3: return [2 /*return*/, Promise.reject("Feed Does Not Exist")];
                                    }
                                });
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        ex_1 = _a.sent();
                        return [2 /*return*/, Promise.reject(ex_1)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ChatServiceInitialStrategy.prototype.createTextFeed = function (message, media, hiveId, circleId) {
        if (media === void 0) { media = ""; }
        if (hiveId === void 0) { hiveId = null; }
        if (circleId === void 0) { circleId = null; }
        return __awaiter(this, void 0, void 0, function () {
            var uniqueId, theFeed, ex_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        uniqueId = (0, uuid_1.v4)();
                        theFeed = {
                            comments: [],
                            communityId: this.communityId,
                            createdAt: firestore_1.Timestamp.now(),
                            hiveId: hiveId,
                            circleId: circleId,
                            id: uniqueId,
                            imageUrl: media,
                            likes: [],
                            postedBy: this.userObject,
                            shareLink: null,
                            text: message
                        };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, firestore_1.runTransaction)(this.db, function (trans) { return __awaiter(_this, void 0, void 0, function () {
                                var newFeedDoc;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, trans.set((0, firestore_1.doc)(this.db, "Feeds/".concat(uniqueId)), theFeed)];
                                        case 1:
                                            newFeedDoc = _a.sent();
                                            return [2 /*return*/, newFeedDoc];
                                    }
                                });
                            }); })];
                    case 2: return [2 /*return*/, _a.sent()];
                    case 3:
                        ex_2 = _a.sent();
                        return [2 /*return*/, Promise.reject(ex_2)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ChatServiceInitialStrategy.prototype.getFeedById = function (feedId) {
        return __awaiter(this, void 0, void 0, function () {
            var feedDocs;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, firestore_1.getDocs)((0, firestore_1.query)((0, firestore_1.collection)(this.db, "/Feeds"), (0, firestore_1.where)("communityId", "==", this.communityId), (0, firestore_1.where)("id", "==", feedId)))];
                    case 1:
                        feedDocs = _a.sent();
                        if (feedDocs.empty) {
                            return [2 /*return*/, null];
                        }
                        else {
                            return [2 /*return*/, __assign(__assign({}, (feedDocs.docs[0].data())), { id: feedDocs.docs[0].id })];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatServiceInitialStrategy.prototype.toggleLikeFeed = function (feedId) {
        return __awaiter(this, void 0, void 0, function () {
            var ex_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, firestore_1.runTransaction)(this.db, function (trans) { return __awaiter(_this, void 0, void 0, function () {
                                var feedDoc, originalLikes, newLikes;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, trans.get((0, firestore_1.doc)(this.db, "Feeds/".concat(feedId)))];
                                        case 1:
                                            feedDoc = _a.sent();
                                            if (!feedDoc) return [3 /*break*/, 3];
                                            originalLikes = feedDoc.data()["likes"];
                                            newLikes = [];
                                            if (originalLikes.map(function (val) { var _a; return (_a = (val === null || val === void 0 ? void 0 : val.userId)) !== null && _a !== void 0 ? _a : val; }).includes(this.userId)) {
                                                newLikes = originalLikes.filter(function (val, ind, arr) {
                                                    var _a;
                                                    return ((_a = val.userId) !== null && _a !== void 0 ? _a : val) != _this.userId;
                                                });
                                                // return await updateDoc(feedDoc.ref, {likes:arrayRemove([this.userId])})
                                            }
                                            else {
                                                newLikes = __spreadArray(__spreadArray([], originalLikes, true), [this.userObject], false);
                                                // return await updateDoc(feedDoc.ref, {likes:arrayUnion([this.userId])})
                                            }
                                            return [4 /*yield*/, trans.update(feedDoc.ref, { likes: newLikes })];
                                        case 2: return [2 /*return*/, _a.sent()];
                                        case 3: return [2 /*return*/, Promise.reject("Feed Does Not Exist")];
                                    }
                                });
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        ex_3 = _a.sent();
                        return [2 /*return*/, Promise.reject(ex_3)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ChatServiceInitialStrategy.prototype.updateShareLinkOfFeed = function (feedId, newLink) {
        return __awaiter(this, void 0, void 0, function () {
            var ex_4;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, firestore_1.runTransaction)(this.db, function (trans) { return __awaiter(_this, void 0, void 0, function () {
                                var feedobj;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, trans.get((0, firestore_1.doc)(this.db, "Feeds/".concat(feedId)))];
                                        case 1:
                                            feedobj = _a.sent();
                                            if (!feedobj) return [3 /*break*/, 3];
                                            return [4 /*yield*/, trans.update(feedobj.ref, { shareLink: newLink })];
                                        case 2: return [2 /*return*/, _a.sent()];
                                        case 3: return [2 /*return*/, Promise.reject("Feed Does Not Exist")];
                                    }
                                });
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        ex_4 = _a.sent();
                        return [2 /*return*/, Promise.reject(ex_4)];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    //Works
    ChatServiceInitialStrategy.prototype.getConversationsWithUser = function (recipientId) {
        return __awaiter(this, void 0, void 0, function () {
            var querySnapShot, obj;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, firestore_1.getDoc)((0, firestore_1.doc)(this.db, "Conversations/".concat(this.userId, "/Recipients/").concat(recipientId)))];
                    case 1:
                        querySnapShot = _a.sent();
                        obj = querySnapShot.data();
                        // return  querySnapShot.docs.map((val)=>{return Object.fromEntries([...Object.entries(val.data()) , ["id",val.id] ]) }) 
                        return [2 /*return*/, Object.fromEntries(__spreadArray(__spreadArray([], Object.entries(obj), true), [["id", querySnapShot.id]], false))];
                }
            });
        });
    };
    //Works
    ChatServiceInitialStrategy.prototype.getfilteredConversationByUserName = function (searchText) {
        var _this = this;
        // console.log("WsALLConv : ", this.wsAllConversationDocs)
        return this.wsAllConversationDocs.filter(function (val, ind, arr) {
            var invites = val["invites"];
            var counter = 0;
            invites.forEach(function (subval, subind, subarr) {
                if (subval["chatUser"]["userId"] != _this.userId && subval["chatUser"]["name"].includes(searchText)) {
                    counter++;
                }
            });
            return counter > 0;
        });
    };
    ChatServiceInitialStrategy.prototype.isConversationExistWithUser = function (recipientId) {
        return __awaiter(this, void 0, void 0, function () {
            var docres;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, firestore_1.getDoc)((0, firestore_1.doc)(this.db, "Conversations/".concat(this.userId, "/Recipients/").concat(recipientId)))];
                    case 1:
                        docres = _a.sent();
                        if (docres.exists()) {
                            return [2 /*return*/, docres.data()];
                        }
                        else {
                            return [2 /*return*/, false];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    // user and recipient object are the data objects you get from social community endpoint
    // this function returns the msgId of the chat document created for the direct message.
    // msgText wont be used, its best to send the message after creating the conversation.
    // createNewDirectConversation FUNCTION IS COMPLETE
    ChatServiceInitialStrategy.prototype.createNewDirectConversation = function (userObject, recipientObject, msgText) {
        if (msgText === void 0) { msgText = ""; }
        return __awaiter(this, void 0, void 0, function () {
            var c_userObject, res, error_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        c_userObject = userObject !== null && userObject !== void 0 ? userObject : this.userObject;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, firestore_1.runTransaction)(this.db, function (trans) { return __awaiter(_this, void 0, void 0, function () {
                                var chatsCollec, newChatDoc, msgCollec, convPairs, resultCopy;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            chatsCollec = (0, firestore_1.collection)(this.db, "Chats");
                                            return [4 /*yield*/, (0, firestore_1.addDoc)(chatsCollec, {
                                                    status: true
                                                })
                                                //Add Message Collection
                                            ];
                                        case 1:
                                            newChatDoc = _a.sent();
                                            msgCollec = (0, firestore_1.collection)(newChatDoc, "Messages");
                                            convPairs = [
                                                [{ chatUser: c_userObject, status: "accepted" }, { chatUser: recipientObject, status: "pending" }],
                                                [{ chatUser: recipientObject, status: "pending" }, { chatUser: c_userObject, status: "accepted" }]
                                            ];
                                            resultCopy = null;
                                            convPairs.forEach(function (convPair, ind, arr) { return __awaiter(_this, void 0, void 0, function () {
                                                var acopy;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0:
                                                            acopy = {
                                                                groupAdmins: [],
                                                                groupId: "",
                                                                groupName: "",
                                                                invites: [
                                                                    convPair[0],
                                                                    convPair[1]
                                                                ],
                                                                isGroup: false,
                                                                // lastMessage: {
                                                                //     lastMessage: msgText,
                                                                //     senderName: userObject["name"],
                                                                //     timeSent: timeSentMsg 
                                                                // },
                                                                lastMessage: null,
                                                                messageId: newChatDoc.id,
                                                                recipients: [
                                                                    convPair[0].chatUser,
                                                                    convPair[1].chatUser
                                                                ],
                                                                conversationType: "direct"
                                                            };
                                                            resultCopy = acopy;
                                                            return [4 /*yield*/, (0, firestore_1.setDoc)((0, firestore_1.doc)(this.db, "Conversations/".concat(convPair[0].chatUser["id"] ? convPair[0].chatUser["id"] : convPair[0].chatUser["userId"], "/Recipients/").concat(convPair[1].chatUser["id"] ? convPair[1].chatUser["id"] : convPair[1].chatUser["userId"])), acopy)];
                                                        case 1:
                                                            _a.sent();
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); });
                                            return [2 /*return*/, resultCopy];
                                    }
                                });
                            }); })
                            // console.log("SuccessFull New Direct Chat Created : ", res)
                            // return 
                        ];
                    case 2:
                        res = _a.sent();
                        // console.log("SuccessFull New Direct Chat Created : ", res)
                        // return 
                        return [2 /*return*/, Promise.resolve(res)];
                    case 3:
                        error_1 = _a.sent();
                        console.log("Error With Creating Direct Chat : ", error_1);
                        return [2 /*return*/, Promise.reject(error_1)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ChatServiceInitialStrategy.prototype.createNewGroupConversation = function (userObject, recipientObject, groupName, forceAcceptance, msgText, forcedID, extraMetaData) {
        if (forceAcceptance === void 0) { forceAcceptance = false; }
        if (msgText === void 0) { msgText = ""; }
        if (forcedID === void 0) { forcedID = ""; }
        if (extraMetaData === void 0) { extraMetaData = { isIncident: false, communityId: "", recipientRoles: "" }; }
        return __awaiter(this, void 0, void 0, function () {
            var res, error_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (!(Object.entries(userObject).length > 0 && recipientObject.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, (0, firestore_1.runTransaction)(this.db, function (trans) { return __awaiter(_this, void 0, void 0, function () {
                                var chatsCollec, newChatDoc, msgCollec, generatedUid, mutatedRecipientObjects, mutatedUserObject, convParticipant;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            chatsCollec = (0, firestore_1.collection)(this.db, "Chats");
                                            return [4 /*yield*/, (0, firestore_1.addDoc)(chatsCollec, {
                                                    status: true
                                                })
                                                //Add Message Collection
                                            ];
                                        case 1:
                                            newChatDoc = _a.sent();
                                            msgCollec = (0, firestore_1.collection)(newChatDoc, "Messages");
                                            generatedUid = forcedID ? forcedID : (0, uuid_1.v4)();
                                            mutatedRecipientObjects = recipientObject.map(function (val, ind, arr) {
                                                return { chatUser: val, status: forceAcceptance ? "accepted" : "pending" };
                                            });
                                            mutatedUserObject = { chatUser: userObject, status: "accepted" };
                                            convParticipant = __spreadArray(__spreadArray([], mutatedRecipientObjects, true), [mutatedUserObject], false);
                                            // .flatMap(
                                            //     (firstVal, indd, arrr)=>{
                                            //         return arrr.map((secVal,inddd,arrrr)=>{return [firstVal,secVal]})
                                            //     }
                                            // );
                                            // // Create Conversations
                                            // const convPairs = [
                                            //     [{chatUser:userObject,status:"accepted"},{chatUser:recipientObject,status:"pending"}], 
                                            //     [{chatUser:recipientObject,status:"pending"},{chatUser:userObject,status:"accepted"}]
                                            // ];
                                            // const convPairs = [recipientObject,]
                                            convParticipant.forEach(function (convPart, ind, arr) { return __awaiter(_this, void 0, void 0, function () {
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0: return [4 /*yield*/, (0, firestore_1.setDoc)((0, firestore_1.doc)(this.db, "Conversations/".concat(convPart.chatUser["id"] ? convPart.chatUser["id"] : convPart.chatUser["userId"], "/Groups/").concat(generatedUid)), {
                                                                groupAdmins: [userObject],
                                                                groupId: generatedUid,
                                                                groupName: groupName,
                                                                invites: __spreadArray([], convParticipant, true),
                                                                isGroup: true,
                                                                lastMessage: null,
                                                                messageId: newChatDoc.id,
                                                                recipients: __spreadArray([], (convParticipant.map(function (val, ind, arr) { return val.chatUser; })), true),
                                                                conversationType: extraMetaData.isIncident ? "incident" : "direct",
                                                                communityId: extraMetaData.communityId,
                                                                recipientRoles: extraMetaData.recipientRoles
                                                            })];
                                                        case 1:
                                                            _a.sent();
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); });
                                            return [2 /*return*/, newChatDoc.id];
                                    }
                                });
                            }); })
                            // console.log("SuccessFull New Group Created : ", res)
                        ];
                    case 1:
                        res = _a.sent();
                        // console.log("SuccessFull New Group Created : ", res)
                        return [2 /*return*/, res];
                    case 2: return [2 /*return*/, Promise.reject("Invalid User or Recipient")];
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        console.log("Error With Creating Direct Chat : ", error_2);
                        return [2 /*return*/, Promise.reject(error_2)];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ChatServiceInitialStrategy.prototype.deleteConversationGroup = function (msgId) {
        return __awaiter(this, void 0, void 0, function () {
            var returnMessage;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        returnMessage = { "state": "Error", "message": "" };
                        return [4 /*yield*/, (0, firestore_1.runTransaction)(this.db, function (trans) { return __awaiter(_this, void 0, void 0, function () {
                                var groupsSnapSHot, recipients, msgId_1, groupId;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, (0, firestore_1.getDocs)(this.QuerygetAllConversationWithSpecificMessageId(msgId, "Groups"))];
                                        case 1:
                                            groupsSnapSHot = _a.sent();
                                            if (this.isGroupAdmin(groupsSnapSHot)) {
                                                recipients = groupsSnapSHot.docs[0].data()["recipients"];
                                                msgId_1 = groupsSnapSHot.docs[0].data()["messageId"];
                                                groupId = groupsSnapSHot.docs[0].data()["groupId"];
                                                //deleting all conversations objects related to group
                                                recipients.forEach(function (grpdoc, ind, arr) { return __awaiter(_this, void 0, void 0, function () {
                                                    return __generator(this, function (_a) {
                                                        switch (_a.label) {
                                                            case 0: 
                                                            // const theGroupConvDoc = doc(this.db, `Conversations/${grpdoc["userId"]}/Groups/${groupId}`)
                                                            // trans.delete(theGroupConvDoc)
                                                            return [4 /*yield*/, this.removeParticipantFromGroup(msgId_1, grpdoc["userId"])];
                                                            case 1:
                                                                // const theGroupConvDoc = doc(this.db, `Conversations/${grpdoc["userId"]}/Groups/${groupId}`)
                                                                // trans.delete(theGroupConvDoc)
                                                                _a.sent();
                                                                return [2 /*return*/];
                                                        }
                                                    });
                                                }); });
                                                // Uncomment this if you want to delete the messages themselfves
                                                // trans.delete(doc(this.db, `Chats/${msgId}`))
                                                returnMessage = { "state": "Successful", "message": "" };
                                            }
                                            else {
                                                returnMessage = { "state": "Error", "message": "You dont have the right previlage" };
                                            }
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, returnMessage];
                }
            });
        });
    };
    ChatServiceInitialStrategy.prototype.userSpecificDeleteChat = function (msgId) {
        return __awaiter(this, void 0, void 0, function () {
            var returnMessage, ex_5;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        returnMessage = { "state": "Error", "message": "" };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, firestore_1.runTransaction)(this.db, function (tran) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    tran.set((0, firestore_1.doc)(this.db, "/Chats/".concat(msgId, "/Deleted/").concat(this.userId)), { timeDeleted: firestore_1.Timestamp.now() });
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        ex_5 = _a.sent();
                        returnMessage = { "state": "Error", "message": "The error : ".concat(ex_5) };
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, returnMessage];
                }
            });
        });
    };
    // async archieveConversationByFBPath ( documentPath : string ){
    //     await runTransaction(
    //         this.db,
    //         (trn) =>{
    //             trn.update(
    //                 doc(this.db, `/Conversations/${this.userId}/Recipients/${docID}`)
    //             )
    //         }
    //     )
    // }
    //Can be used bore both Archiving and UnArchiving
    ChatServiceInitialStrategy.prototype.updateArchieveConversationStateByDocID = function (docID, value) {
        if (value === void 0) { value = false; }
        return __awaiter(this, void 0, void 0, function () {
            var returnMessage, ex_6;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        returnMessage = { state: "Error", message: "Arhieve Operation Failed" };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, (0, firestore_1.runTransaction)(this.db, function (trn) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    trn.update((0, firestore_1.doc)(this.db, "/Conversations/".concat(this.userId, "/Recipients/").concat(docID)), {
                                        "isArchived": value,
                                    });
                                    return [2 /*return*/];
                                });
                            }); })];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        ex_6 = _a.sent();
                        returnMessage = { state: "Error", message: "The Error : ".concat(ex_6) };
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, returnMessage];
                }
            });
        });
    };
    ChatServiceInitialStrategy.prototype.createConv = function (participantsObject, acceptedParticipants, rejectedParticipants, existingParticipants, msgCollec, existingInvitees) {
        if (acceptedParticipants === void 0) { acceptedParticipants = []; }
        if (rejectedParticipants === void 0) { rejectedParticipants = []; }
        if (existingParticipants === void 0) { existingParticipants = []; }
        if (existingInvitees === void 0) { existingInvitees = []; }
        return __awaiter(this, void 0, void 0, function () {
            var combinedObject, inviteesObj;
            var _this = this;
            return __generator(this, function (_a) {
                combinedObject = participantsObject;
                inviteesObj = __spreadArray([], combinedObject.map(function (val, ind, arr) {
                    return acceptedParticipants.includes(val)
                        ? {
                            chatuser: val,
                            status: "accepted"
                        }
                        : (rejectedParticipants.includes(val)
                            ? {
                                chatUser: val,
                                status: "denied"
                            } : {
                            chatUser: val,
                            status: "pending"
                        });
                }), true);
                //Create Individual Conversation Objects
                // This takes all participants and creates a conversation between them if a conversation object does not exist
                combinedObject.forEach(function (reciverObj, ind, arr) { return __awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        arr.forEach(function (nestedObj, nestedind, nestedarr) { return __awaiter(_this, void 0, void 0, function () {
                            var theDoc, res;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        theDoc = (0, firestore_1.doc)(this.db, "conversation/".concat(reciverObj["id"], "/Recipients/").concat(nestedObj["id"]));
                                        return [4 /*yield*/, (0, firestore_1.getDoc)(theDoc)];
                                    case 1:
                                        res = _a.sent();
                                        if (!!res.exists()) return [3 /*break*/, 3];
                                        return [4 /*yield*/, (0, firestore_1.setDoc)(theDoc, {
                                                groupAdmins: [],
                                                groupId: "",
                                                groupName: "",
                                                invites: inviteesObj,
                                                isGroup: false,
                                                lastMessage: null,
                                                messageId: msgCollec.id,
                                                recipients: __spreadArray([], participantsObject, true)
                                            })];
                                    case 2:
                                        _a.sent();
                                        _a.label = 3;
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                    });
                }); });
                return [2 /*return*/, msgCollec.id];
            });
        });
    };
    // autoUpdateLastMessage FUNCTION IS COMPLETE
    // rember to call this after send a message but it can be called anytime,
    // you want to update the Last Message of conversations, it works whether 
    // a message has been sent or not. Heck you 
    // msgCollec : CollectionReference, msgDoc: DocumentReference
    ChatServiceInitialStrategy.prototype.autoUpdateLastMessage = function (msgChannelId, groupOrRecipient) {
        if (groupOrRecipient === void 0) { groupOrRecipient = "Recipients"; }
        return __awaiter(this, void 0, void 0, function () {
            var msgCollec, msgDoc, queryResultlatestMessage, latestMessage, temp12, getDocsResult, recipientsList;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        msgCollec = (0, firestore_1.collection)(this.db, "/Chat/".concat(msgChannelId, "/Messages"));
                        msgDoc = (0, firestore_1.doc)(this.db, "/Chats/".concat(msgChannelId));
                        return [4 /*yield*/, (0, firestore_1.getDocs)(this.QuerygetLatestMessage(msgDoc.id))
                            // console.log( "QueryLatestMessageResult : ", Object.entries(queryResultlatestMessage) )
                        ];
                    case 1:
                        queryResultlatestMessage = _a.sent();
                        latestMessage = null;
                        if (queryResultlatestMessage.empty) {
                            // console.log("   QueryLatestMessageResult is !!EMPTY!!")
                            latestMessage = null;
                        }
                        else {
                            temp12 = queryResultlatestMessage.docs[0].data();
                            // console.log("   QueryLatestMessageResut Element : ", Object.entries(temp12))
                            // console.log("   QueryLatestMessageResut Element Sender : ", temp12["sender"])
                            latestMessage = {
                                lastMessage: temp12["chat"],
                                senderName: temp12["sender"] ? temp12["sender"]["name"] : "",
                                senderId: temp12["sender"] ? temp12["sender"]["userId"] : "",
                                timeSent: temp12["timeSent"],
                                chatMediaType: temp12["chatMediaType"],
                                // read: false, // Readstate is set bellow
                            };
                        }
                        return [4 /*yield*/, (0, firestore_1.getDocs)(this.QuerygetConversationWithWithSpecificMessageIdNUserId(this.userId, msgDoc.id, groupOrRecipient))
                            // console.log("GET DOCS REUSLTS : ", this.QuerygetConversationWithWithSpecificMessageIdNUserId(this.userId,))
                            // console.log("   GET DOCS REUSLTS : ", this.userId, msgCollec.id)
                            // console.log("   Conversation With out Message ID : ", Object.entries(getDocsResult))
                        ];
                    case 2:
                        getDocsResult = _a.sent();
                        recipientsList = getDocsResult.docs[0].data()["recipients"];
                        recipientsList.forEach(function (chatUser, ind, arr) { return __awaiter(_this, void 0, void 0, function () {
                            var theDocs;
                            var _this = this;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, (0, firestore_1.getDocs)(this.QuerygetConversationWithWithSpecificMessageIdNUserId(chatUser["userId"], msgDoc.id, groupOrRecipient))
                                        // Update last message for each
                                    ];
                                    case 1:
                                        theDocs = _a.sent();
                                        // Update last message for each
                                        theDocs.forEach(function (adoc) { return __awaiter(_this, void 0, void 0, function () {
                                            var readState;
                                            return __generator(this, function (_a) {
                                                switch (_a.label) {
                                                    case 0:
                                                        readState = adoc.ref.path.includes("Conversations/".concat(this.userId)) ? true : false;
                                                        return [4 /*yield*/, (0, firestore_1.updateDoc)(adoc.ref, {
                                                                lastMessage: __assign(__assign({}, latestMessage), { read: readState })
                                                            })];
                                                    case 1:
                                                        _a.sent();
                                                        return [2 /*return*/];
                                                }
                                            });
                                        }); });
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatServiceInitialStrategy.prototype.updateAllUserObjects = function (userId, newUserData) {
        return __awaiter(this, void 0, void 0, function () {
            var q1r, q2r, allConvs, f_all, all_messages;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, firestore_1.getDocs)((0, firestore_1.collectionGroup)(this.db, "Groups"))];
                    case 1:
                        q1r = _a.sent();
                        return [4 /*yield*/, (0, firestore_1.getDocs)((0, firestore_1.collectionGroup)(this.db, "Recipients"))];
                    case 2:
                        q2r = _a.sent();
                        allConvs = q1r.docs.concat(q2r.docs);
                        allConvs.forEach(function (val, ind, arr) { return __awaiter(_this, void 0, void 0, function () {
                            var updateData, theData, theRef, theInvites, theRecipients, newInvites, newRecipients;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        updateData = false;
                                        theData = val.data();
                                        theRef = val.ref;
                                        theInvites = theData["invites"];
                                        theRecipients = theData["recipients"];
                                        newInvites = theInvites.map(function (valinv, indinv, arrinv) {
                                            if (valinv["chatUser"]["userId"] == userId) {
                                                updateData = true;
                                                return __assign(__assign({}, valinv), { chatUser: newUserData });
                                            }
                                            else {
                                                return valinv;
                                            }
                                            // return valinv["chatUser"]["userId"] == userId ? newUserData : valinv
                                        });
                                        newRecipients = theRecipients.map(function (valrec, indrec, arrrec) {
                                            if (valrec["userId"] == userId) {
                                                updateData = true;
                                                return __assign(__assign({}, valrec), newUserData);
                                            }
                                            else {
                                                return valrec;
                                            }
                                        });
                                        return [4 /*yield*/, (0, firestore_1.updateDoc)(theRef, {
                                                invites: newInvites,
                                                recipients: newRecipients
                                            })];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, (0, firestore_1.getDocs)((0, firestore_1.collectionGroup)(this.db, "Feeds"))];
                    case 3:
                        f_all = _a.sent();
                        f_all.docs.forEach(function (val, ind, arr) { return __awaiter(_this, void 0, void 0, function () {
                            var updateData, theData, theRef, theComments, postedBy, newComments, newPostedBy;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        updateData = false;
                                        theData = val.data();
                                        theRef = val.ref;
                                        theComments = theData["comments"];
                                        postedBy = theData["postedBy"];
                                        newComments = theComments.map(function (valcom, indcom, arrcom) {
                                            if (valcom["commenter"]["userId"] == userId) {
                                                updateData = true;
                                                return __assign(__assign({}, valcom), { commenter: newUserData });
                                            }
                                            else {
                                                return valcom;
                                            }
                                        });
                                        newPostedBy = postedBy;
                                        if (postedBy["userId"] == userId) {
                                            updateData = true;
                                            newPostedBy = __assign(__assign({}, postedBy), newUserData);
                                        }
                                        if (!updateData) return [3 /*break*/, 2];
                                        return [4 /*yield*/, (0, firestore_1.updateDoc)(theRef, {
                                                comments: newComments,
                                                postedBy: newPostedBy
                                            })];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [4 /*yield*/, (0, firestore_1.getDocs)((0, firestore_1.collectionGroup)(this.db, "Messages"))];
                    case 4:
                        all_messages = _a.sent();
                        all_messages.docs.forEach(function (val, ind, arr) { return __awaiter(_this, void 0, void 0, function () {
                            var updateData, theData, theRef, theSender, theRecipients, newSender, newRecipients;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        updateData = false;
                                        theData = val.data();
                                        theRef = val.ref;
                                        theSender = theData["sender"];
                                        theRecipients = theData["recipients"];
                                        newSender = theSender;
                                        if (theSender["userId"] == userId) {
                                            updateData = true;
                                            newSender = __assign(__assign({}, theSender), newUserData);
                                        }
                                        newRecipients = theRecipients.map(function (valrec, indrec, arrrec) {
                                            if (valrec["userId"] == userId) {
                                                updateData = true;
                                                return __assign(__assign({}, valrec), newUserData);
                                            }
                                            else {
                                                return valrec;
                                            }
                                        });
                                        if (!updateData) return [3 /*break*/, 2];
                                        return [4 /*yield*/, (0, firestore_1.updateDoc)(theRef, {
                                                sender: newSender,
                                                recipients: newRecipients
                                            })];
                                    case 1:
                                        _a.sent();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    //Works
    ChatServiceInitialStrategy.prototype.getMessages = function (msgId) {
        return __awaiter(this, void 0, void 0, function () {
            var q, querySnapShot;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        q = this.QuerygetMessagesById(msgId);
                        return [4 /*yield*/, (0, firestore_1.getDocs)(q)];
                    case 1:
                        querySnapShot = _a.sent();
                        return [2 /*return*/, querySnapShot.docs.map(function (val) { return Object.fromEntries(__spreadArray(__spreadArray([], Object.entries(val.data()), true), [["id", val.id]], false)); })];
                }
            });
        });
    };
    //Works
    ChatServiceInitialStrategy.prototype.subscribeToMessageEventHandler = function (msgId, next, error) {
        return __awaiter(this, void 0, void 0, function () {
            var td, theDeleteDoc, unsubscribecallback;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        td = null;
                        return [4 /*yield*/, (0, firestore_1.getDoc)((0, firestore_1.doc)(this.db, "/Chats/".concat(msgId, "/Deleted/").concat(this.userId)))];
                    case 1:
                        theDeleteDoc = _a.sent();
                        if (theDeleteDoc.exists()) {
                            // console.log("Delete Doc Exists")
                            td = theDeleteDoc.data().timeDeleted;
                        }
                        unsubscribecallback = (0, firestore_1.onSnapshot)(td ? this.QuerygetMessagesByIdAndTime(msgId, td) : this.QuerygetMessagesById(msgId), {
                            next: function (data) {
                                var retdata = data.docs.map(function (val, ind, arr) {
                                    return __assign({ docId: val.id }, val.data());
                                });
                                next(retdata);
                            },
                            error: error
                        });
                        // console.log("TD STATE : " ,td, "MSG ID " , msgId)
                        this.unSubscribeArrayList.push(unsubscribecallback);
                        return [2 /*return*/, unsubscribecallback];
                }
            });
        });
    };
    //  sendMessgae FUNCTION IS COMPLETE
    //  remeber call AUTOUPDATELASTMESSAGE after sending a message
    ChatServiceInitialStrategy.prototype.sendMessage = function (conversationId, msgId, text, groupOrRecipient) {
        return __awaiter(this, void 0, void 0, function () {
            var promiseResult, error_3;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, firestore_1.runTransaction)(this.db, function (trans) { return __awaiter(_this, void 0, void 0, function () {
                                var collec, recipients, groupId, collecGroup, docRef;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            collec = (0, firestore_1.collection)(this.db, "/Chats/".concat(msgId, "/Messages"));
                                            recipients = [];
                                            groupId = "";
                                            return [4 /*yield*/, (0, firestore_1.getDocs)((0, firestore_1.query)((0, firestore_1.collectionGroup)(this.db, groupOrRecipient), (0, firestore_1.where)("messageId", "==", msgId)))
                                                // collecGroup.docs[0].data()
                                            ];
                                        case 1:
                                            collecGroup = _a.sent();
                                            // collecGroup.docs[0].data()
                                            if (!collecGroup.empty) {
                                                recipients = __spreadArray([], collecGroup.docs[0].data()["recipients"], true);
                                                groupId = groupOrRecipient == "Groups" ? collecGroup.docs[0].data()["groupId"] : "";
                                            }
                                            return [4 /*yield*/, (0, firestore_1.addDoc)(collec, {})];
                                        case 2:
                                            docRef = _a.sent();
                                            return [4 /*yield*/, (0, firestore_1.setDoc)(docRef, {
                                                    id: docRef.id,
                                                    chat: text,
                                                    groupId: groupId,
                                                    mediaUrl: null,
                                                    chatMediaType: "none",
                                                    recipients: recipients.filter(function (val, ind, arr) {
                                                        return val["userId"] != _this.userId;
                                                    }), //This object does not really matter,
                                                    sender: recipients.find(function (val, ind, arr) {
                                                        return val["userId"] == _this.userId;
                                                    }), //
                                                    timeSent: new Date()
                                                })];
                                        case 3:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })
                            // const setDocRes = await getDoc(docRef)
                            // const setDocResData = setDocRes.data()
                            // return { "isSuccessful" : true }
                        ];
                    case 1:
                        promiseResult = _a.sent();
                        // const setDocRes = await getDoc(docRef)
                        // const setDocResData = setDocRes.data()
                        // return { "isSuccessful" : true }
                        return [2 /*return*/, Promise.resolve({ "isSuccessful": true })];
                    case 2:
                        error_3 = _a.sent();
                        // return { "isSuccessful" : false, message: error}
                        return [2 /*return*/, Promise.reject({ "isSuccessful": false, message: error_3 })];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ChatServiceInitialStrategy.prototype.sendImage = function (msgId, mediaUrl, groupOrRecipient) {
        return __awaiter(this, void 0, void 0, function () {
            var promiseResult, error_4;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, firestore_1.runTransaction)(this.db, function (trans) { return __awaiter(_this, void 0, void 0, function () {
                                var collec, recipients, groupId, collecGroup, docRef;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            collec = (0, firestore_1.collection)(this.db, "/Chats/".concat(msgId, "/Messages"));
                                            recipients = [];
                                            groupId = "";
                                            return [4 /*yield*/, (0, firestore_1.getDocs)((0, firestore_1.query)((0, firestore_1.collectionGroup)(this.db, groupOrRecipient), (0, firestore_1.where)("messageId", "==", msgId)))
                                                // collecGroup.docs[0].data()
                                            ];
                                        case 1:
                                            collecGroup = _a.sent();
                                            // collecGroup.docs[0].data()
                                            if (!collecGroup.empty) {
                                                recipients = __spreadArray([], collecGroup.docs[0].data()["recipients"], true);
                                                groupId = groupOrRecipient == "Groups" ? collecGroup.docs[0].data()["groupId"] : "";
                                            }
                                            return [4 /*yield*/, (0, firestore_1.addDoc)(collec, {})];
                                        case 2:
                                            docRef = _a.sent();
                                            return [4 /*yield*/, (0, firestore_1.setDoc)(docRef, {
                                                    id: docRef.id,
                                                    chat: "",
                                                    groupId: groupId,
                                                    mediaUrl: mediaUrl,
                                                    chatMediaType: "image",
                                                    recipients: recipients.filter(function (val, ind, arr) {
                                                        return val["userId"] != _this.userId;
                                                    }), //This object does not really matter,
                                                    sender: recipients.find(function (val, ind, arr) {
                                                        return val["userId"] == _this.userId;
                                                    }), //
                                                    timeSent: new Date()
                                                })];
                                        case 3:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1:
                        promiseResult = _a.sent();
                        return [2 /*return*/, Promise.resolve({ "isSuccessful": true })];
                    case 2:
                        error_4 = _a.sent();
                        return [2 /*return*/, Promise.reject({ "isSuccessful": false, message: error_4 })];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Tested, Working Now
    // You can use this function to accept and deny a conversation at anytime
    ChatServiceInitialStrategy.prototype.acceptOrDeclineConversationInvite = function (msgId, isAccept) {
        return __awaiter(this, void 0, void 0, function () {
            var error_5;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, (0, firestore_1.runTransaction)(this.db, function (transactor) { return __awaiter(_this, void 0, void 0, function () {
                                var snapshotData;
                                var _this = this;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, (0, firestore_1.getDocs)(this.QuerygetAllConversationWithSpecificMessageId(msgId))];
                                        case 1:
                                            snapshotData = _a.sent();
                                            // console.log("CONV OBJ is Empty: ", snapshotData.empty, snapshotData.docs.length)
                                            // forEach conversations linked to msgId
                                            snapshotData.forEach(function (data) { return __awaiter(_this, void 0, void 0, function () {
                                                var invitees, newInvitee;
                                                var _this = this;
                                                return __generator(this, function (_a) {
                                                    switch (_a.label) {
                                                        case 0:
                                                            invitees = data.data()["invites"];
                                                            newInvitee = [];
                                                            // update invite array within conversation to reflect chat acceptance or denial
                                                            invitees.forEach(function (val, ind, arr) {
                                                                if (val["chatUser"]["userId"] == _this.userId) {
                                                                    newInvitee.push(__assign(__assign({}, val), { status: isAccept ? "accepted" : "denied" }));
                                                                }
                                                                else {
                                                                    newInvitee.push(__assign({}, val));
                                                                }
                                                            });
                                                            // update firebase with new invite list
                                                            return [4 /*yield*/, transactor.update(data.ref, __assign(__assign({}, data.data()), { invites: __spreadArray([], newInvitee, true) }))];
                                                        case 1:
                                                            // update firebase with new invite list
                                                            _a.sent();
                                                            return [2 /*return*/];
                                                    }
                                                });
                                            }); });
                                            return [2 /*return*/];
                                    }
                                });
                            }); })];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        error_5 = _a.sent();
                        return [2 /*return*/, Promise.reject({ isSuccessful: false, error: error_5 })];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ChatServiceInitialStrategy.prototype.updateParticipantsBasedOnInviteStates = function (msgId) {
        return __awaiter(this, void 0, void 0, function () {
            var snapshotData;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, firestore_1.getDocs)(this.QuerygetAllConversationWithSpecificMessageId(msgId))];
                    case 1:
                        snapshotData = _a.sent();
                        // console.log("CONV OBJ is Empty: ", snapshotData.empty, snapshotData.docs.length)
                        // forEach conversations linked to msgId
                        snapshotData.forEach(function (data) { return __awaiter(_this, void 0, void 0, function () {
                            var invitees, acceptedInvitee;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        invitees = data.data()["invites"];
                                        acceptedInvitee = invitees
                                            .filter(function (val, ind, arr) { return val.status == "accepted"; })
                                            .map(function (val, ind, arr) { return val.chatUser; });
                                        // update firebase with new participant/recipients list
                                        return [4 /*yield*/, (0, firestore_1.updateDoc)(data.ref, __assign(__assign({}, data.data()), { recipients: __spreadArray([], acceptedInvitee, true) }))];
                                    case 1:
                                        // update firebase with new participant/recipients list
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                        return [2 /*return*/];
                }
            });
        });
    };
    ChatServiceInitialStrategy.prototype.markLatestMessageAsRead = function (msgId) {
        return __awaiter(this, void 0, void 0, function () {
            var convResultsR, convResultsG;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, firestore_1.getDocs)(this.QuerygetAllConversationWithSpecificMessageId(msgId, "Recipients"))];
                    case 1:
                        convResultsR = _a.sent();
                        return [4 /*yield*/, (0, firestore_1.getDocs)(this.QuerygetAllConversationWithSpecificMessageId(msgId, "Groups"))];
                    case 2:
                        convResultsG = _a.sent();
                        return [2 /*return*/, __spreadArray(__spreadArray([], convResultsR.docs, true), convResultsG.docs, true).every(function (val, ind, arr) { return __awaiter(_this, void 0, void 0, function () {
                                var lastMessage, readState;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            lastMessage = val.data()["lastMessage"];
                                            if (!val.ref.path.includes("Conversations/".concat(this.userId))) return [3 /*break*/, 3];
                                            readState = true;
                                            if (!lastMessage) return [3 /*break*/, 2];
                                            return [4 /*yield*/, (0, firestore_1.updateDoc)(val.ref, { lastMessage: __assign(__assign({}, lastMessage), { read: readState }) })];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2: return [2 /*return*/, ind == arr.length - 1 ? true : false];
                                        case 3: return [2 /*return*/, true];
                                    }
                                });
                            }); })];
                }
            });
        });
    };
    // async setReadStatusOfLatestMessage(msgId: string){
    //    const convlist = await getDocs(this.QuerygetAllConversationWithSpecificMessageId(msgId));
    //    convlist.docs.forEach((val, ind, arr)=>{    
    //         const lastMessage = val.data()["lastMessage"]
    //         val.ref.path
    //         if(lastMessage && val.ref.path.includes(`Conversations/${this.userId}`)){
    //             updateDoc(val.ref,{lastMessage:{...lastMessage, read:true}})
    //         }else if(lastMessage){
    //             updateDoc(val.ref,{lastMessage:{...lastMessage, read:false}})
    //         }
    //    })
    // }
    ChatServiceInitialStrategy.prototype.finalize = function () {
        this.unSubscribeArrayList.forEach(function (val) { return val(); });
    };
    return ChatServiceInitialStrategy;
}());
exports.ChatServiceInitialStrategy = ChatServiceInitialStrategy;
